<template>
  <div class="question" :class="{ 'authentication': question.attestationState == 1,'verification':question.isVerification}" v-loading="loading">
    <div class="head">
      <div class="small-title">
        <span class="has-dot" v-if="question.year">{{ question.year | date("yyyy") }}</span>
        <span class="has-dot" v-if="question.address">{{ question.address }}</span>
        <!-- <span class="has-dot" v-if="question.classLevel">{{ question.classLevel | classLevel }}</span> -->
        <span class="has-dot" v-if="question.sourceTypeName">{{ question.sourceTypeName }}</span>
        <span v-if="question.source" class="link ml-5" @click="turnPage('source', question.source)">{{ question.source}}</span>
        <span class="has-dot" v-if="question.importRemark && showInfo">{{ question.importRemark }}</span>
      </div>
      <div class="title">
        <span class="num" v-if="index">{{ index }}、</span>
        <el-tag effect="dark" disable-transitions size="mini" v-if="showType">{{ question.questionType | questionType(question.questionTypeTag) }}</el-tag>
        <div v-html="question.content" class="content-html" style="padding-top: 1px"></div>
      </div>
      <div class="edit">
        <template v-if="editable">
          <el-tag type="success" v-if="question.isVerification" size="mini" disable-transitions>已检查</el-tag>
          <span class="icon el-icon-edit-outline" title="编辑" @click="edited"></span>
          <span class="icon el-icon-delete" title="删除" @click="deleted"></span>
        </template>
        <slot name="edit"></slot>
      </div>
    </div>
    <ul class="options" v-if="question.questionOptionViewModels.length > 0">
      <li v-for="(item, index) in question.questionOptionViewModels" :class="{ 'is-right': item.isRight }" :key="index">
        <span class="order-sort mr-5" v-if="question.questionType == 4" v-html="item.orderSort"></span>
        <span class="order" v-else>{{ getEN(index) }}、</span>
        <div v-html="item.optionContent" class="content-html"></div>
      </li>
    </ul>
    <div class="items answer" v-if="question.questionType != 6">
      <span class="items-label">参考答案：</span>
      <div class="answer-content content-html" :class="['type' + question.questionType]">
        <template v-if="question.questionType == 1 || question.questionType == 2">
          <span v-for="(item, index) in question.answer" :key="index" v-html="item"></span>
        </template>
        <template v-else-if="question.questionType == 3">
          <span v-for="(item, index) in question.answer" :key="index">
            <span v-if="item + '' == 'true'" class="font-16"><i class="iconfont icon-ic_accepted"></i></span>
            <span v-else-if="item + '' == 'false'" class="font-16"><i class="iconfont icon-cuowu"></i></span>
            <span v-else>{{ item }}</span>
          </span>
        </template>
        <template v-else-if="question.questionType == 4">
          <span class="order-sort" v-for="(item, index) in question.answer" :key="index" v-html="item"></span>
        </template>
        <template v-else>
          <div v-for="(item, index) in question.questionObjectiveAnswerViewModels" class="fx-box fx-wrap mr-10" :key="index">
            <div v-html="item.answerContent" class=""></div>
            <div v-for="sItem in item.similarityAnswers" :key="sItem.id" v-html="' / '+sItem.answerContent" class="fx-box"></div>
          </div>
        </template>
      </div>
    </div>
    <div class="items" v-if="question.knowledgePointViewModels.length > 0">
      <span class="items-label">知识点：</span>
      <div class="items-content">
        <span style="display: inline-block;margin-top: 0px;" v-for="(item, index) in question.knowledgePointViewModels" :key="index" @click="turnPage('knowledge', item)">
          <el-link>{{ item.name }}</el-link>
          <span v-if="index < question.knowledgePointViewModels.length - 1">；</span>
        </span>
        <span v-if="question.knowledgePointViewModels && question.knowledgePointViewModels.length == 0" style="color:#999">未设置</span>
      </div>
    </div>
    <div class="items" v-if="question.questionType != 6 && (platform == 'ms' || question.variant)">
      <span class="items-label">问题类型：</span>
      <div class="items-content">
        <span v-if="question.variant">{{ question.variant }}</span>
        <span v-if="!question.variant && platform=='ms'" style="color:#999">未设置</span>
      </div>
    </div>
    <div class="question-child" @click.stop v-if="question.questionType == 6 && showChildren">
      <el-collapse>
        <el-collapse-item>
          <template slot="title">
            <p class="font-weight font-15 color-333">共有子级题目<span class="color-primary" style="margin: 0 2px;">{{ question.childrenQuestionCount }}</span>题</p>
          </template>
          <single-question v-for="(data, index) in question.childrenQuestion" :key="index" :data="data" :index="index + 1" :is-edit="childEditable" :showInfo="showInfo" :showAnalysis="showAnalysis" @callback="childrenCallBack"
            :showType="showType"></single-question>
          <div class="mt-10 mb-15" v-if="childEditable && (type == 'system' || type == 'chapter')">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="addChildren">添加题目</el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="info">
      <div class="info-head">
        <span>难度：
          <el-rate style="display:inline" v-model="question.difficulty" :colors="['#f56c6c', '#f56c6c', '#f56c6c']" disabled disabled-void-color="#ccc">
          </el-rate>
        </span>
        <span v-if="question.subjectCatalogueName">专业课程：{{ question.subjectCatalogueName }}</span>
        <template v-if="showInfo">
          <span>使用次数：{{ question.testPaperCount || 0 }}</span>
          <span>修改次数：{{ question.modifyCount || 0 }}</span>
          <!-- <span>收藏次数：{{ question.collectionCount || 0 }}</span> -->
          <span>创建人：{{ question.createUserName }}</span>
          <span>创建时间：{{ question.createTime | date("yyyy.MM.dd HH:mm") }}</span>
          <span class="inline-flex" v-if="showSimilarity">
            <span>相似题：</span>
            <el-link type="danger" v-if="question.similarityCount > 0" @click="turnPage('similarity', question)" style="margin-top: -3px;">
              <b style="color: #F56C6C;">{{ question.similarityCount }}</b>道</el-link>
            <span v-else>{{ question.similarityCount }} 道</span>
          </span>
          <span v-if="similarityItem.id && similarityItem.id != question.id">相似度：<b class="color-red font-15">{{question.similarity | percent(1, 2) }}</b></span>
          <span v-if="similarityItem.id && similarityItem.id == question.id" c>相似度：<b class="color-blue font-15">原题</b></span>
          <span v-if="question.attestationTime">认证时间：{{ question.attestationTime | date("yyyy.MM.dd HH:mm") }}</span>
          <span v-if="question.tenantName">来源单位：{{ question.tenantName }}</span>
        </template>
        <div class="right" v-if="question.questionType != 6">
          <span :class="{ 'active': analysisShow }" @click.stop="analysisContentShow">
            <small>解析</small>
          </span>
        </div>
      </div>
      <div class="info-body" v-if="analysisShow && question.questionType != 6">
        <div class="analysis content-html" v-html="question.questionAnswerAnalysisContent"></div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    data: {
      type: Object,
    },
    index: {
      type: Number,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isChildEdit: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: Boolean,
      default: true,
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
    showAnalysis: {
      type: Boolean,
      default: true,
    },
    showSimilarity: {
      type: Boolean,
      default: false,
    },
    similarityItem: {
      type: Object,
      default: () => { return {} },
    },
    showChildren: {
      type: Boolean,
      default: true,
    },
    type: "",
  },
  data() {
    return {
      question: {
        knowledgePointViewModels: [],
        answer: [],
        questionOptionViewModels: [],
      },
      loading: false,
      questionVisible: false,
      editable: false,
      childEditable: false,
      query: {},
      analysisShow: false,
      activeNames: [],
      platform: this.$root.tenantInfo.code == '1' ? 'ms' : location.pathname.replace(/\//g, "") || "pc",
    }
  },
  watch: {
    data(val) {
      this.getDatas(val);
    },
    '$route'() {
      this.query = this.$route.query;
    },
  },
  created() {
    this.query = this.$route.query || {};
    this.editable = this.isEdit;
    this.childEditable = this.editable || this.isChildEdit;
    this.analysisShow = this.showAnalysis;
  },
  mounted() {
    this.getDatas(this.data);
  },
  methods: {
    getDatas(data) {
      if (!data.id) {
        return;
      }
      data.questionObjectiveAnswerViewModels = data.questionObjectiveAnswerViewModels || [];
      data.answer = [];
      if (data.questionType == 1 || data.questionType == 2) {
        data.questionOptionViewModels.map((item, index) => {
          if (item.isTrue) {
            data.answer.push(this.getEN(index));
          }
        })
      } else {
        data.answer = data.questionObjectiveAnswerViewModels.map(item => {
          let name = item.answerArray || this.getText(item.answerContent);
          if (item.similarityAnswers && item.similarityAnswers.length > 0) {
            name = name + " / " + item.similarityAnswers.map(sim => { return sim.answerArray || this.getText(sim.answerContent) }).join(" / ");
          }
          return name;
        });
      }
      this.question = data;
    },
    getEN(i) {
      return String.fromCharCode(i + 65);
    },
    deleted() {
      if (this.type == "system" || this.type == "chapter") {
        this.$confirm('是否确定删除该题目？', '操作提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params = {
            id: this.question.id,
          }
          if (this.type == "chapter") {
            params.curriculumChapterId = this.data.curriculumChapterId;
          }
          this.loading = true;
          this.https("delete", "/api/Question/DelQuestion", params).then(res => {
            this.loading = false;
            if (res.success) {
              this.$emit("callback", "success");
            } else {
              this.func.message("error", res.msg);
            }
          }).catch(res => {
            this.loading = false;
          })
        })
      } else {
        this.$emit("callback", "delete", this.question);
      }
    },
    edited() {
      this.$emit("callback", "edit", this.question);
    },
    analysisContentShow() {
      this.analysisShow = !this.analysisShow;
      this.$forceUpdate();
    },
    turnPage(type, item) {
      this.$emit("callback", type, item);
    },
    addExport() {
      this.question.isAdd = !this.question.isAdd;
      this.$emit("export", this.question)
      this.$forceUpdate();
    },
    addChildren() {
      this.$emit("callback", "children", this.data);
    },
    childrenCallBack(type, data) {
      this.$emit("callback", type, data);
    },
    getText(str) {
      if (!str) {
        return "";
      }
      return str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
    },
  },
}
</script>
<style lang="scss">
.question-child {
  margin-top: 15px;
  padding: 2px 15px;
  border: 1px solid #e6e6e6;
  background-color: #f6f6f6;
  .el-collapse-item__header {
    background-color: transparent;
    border-bottom: none;
  }
  .el-collapse-item__wrap {
    background-color: transparent;
    border-bottom: none;
  }
}
</style>
<style lang="scss" scoped>
.question {
  position: relative;
  border: 1px solid #e6e6e6;
  padding: 15px 20px 0px 20px;
  margin-bottom: 15px;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;

  &.authentication {
    background-image: url("/assets/images/authentication.png");
    background-repeat: no-repeat;
    background-size: 54px auto;
  }

  .head {
    position: relative;

    .small-title {
      margin-bottom: 5px;
      margin-top: -5px;
      color: #999;
      font-size: 13px;

      .has-dot {
        &:last-child {
          &::after {
            content: none;
          }
        }

        &::after {
          content: "";
          width: 4px;
          height: 4px;
          display: inline-block;
          vertical-align: middle;
          background-color: #999;
          border-radius: 50%;
          margin: 0 2px;
        }
      }

      .link {
        &:hover {
          cursor: pointer;
          text-decoration: underline;
          color: #555;
        }
      }
    }

    .title {
      display: block;
      // padding-right: 130px;
      .num {
        white-space: nowrap;
        // margin-left: -25px;
        float: left;
        // width: 25px;
      }
      .el-tag {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        float: left;
        height: 18px;
        line-height: 18px;
        min-width: 35px;
        border-radius: 2px;
        margin-right: 3px;
        font-size: 11px;
      }
    }

    .edit {
      margin: 0 0 0 0;
      position: absolute;
      right: -10px;
      top: -5px;
      background-color: #fff;
      display: flex;
      align-items: center;
      padding: 5px 10px;
      // min-width: 70px;
      .icon {
        font-size: 17px;
        margin: 0 0 0 10px;
        &:first-child {
          margin: 0 0 0 0;
        }
        &:hover {
          cursor: pointer;
          color: #04adc0;
        }
      }
    }
  }

  .options {
    margin: 10px 0 0 0;

    & > li {
      // line-height: 18px;
      position: relative;
      display: flex;
      margin: 5px 0;

      &.is-right {
        color: #01a275;
      }

      .order {
        position: relative;
        display: flex;
        align-items: center;
      }
    }
  }

  .items {
    display: flex;
    margin: 10px 0;

    .items-label {
      text-align: right;
      display: inline-block;
      white-space: nowrap;
      vertical-align: middle;
      position: relative;
    }
  }

  .info {
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: 0px;
    margin-top: 15px;

    .info-head {
      background-color: #f8f8f8;
      padding: 8px 60px 8px 20px;
      position: relative;

      & > span {
        margin-right: 15px;
        line-height: 20px;
      }

      .right {
        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0px;

        & > span {
          height: 100%;
          display: flex;
          align-items: center;
          padding: 0 10px;
          color: #2e9d9f;
          border: 1px solid transparent;
          user-select: none;

          &:hover {
            opacity: 0.8;

            small {
              cursor: pointer;
            }
          }

          &.active {
            background-color: #fff;
            border: 1px solid #e6e6e6;
            border-bottom: none;
          }
        }
      }
    }

    .info-body {
      padding: 15px 20px;
    }
  }

  .order-sort {
    display: inline-block;
    border: 1px solid #aaa;
    background-color: #fff;
    color: #555;
    width: 20px;
    height: 20px;
    text-align: center;
    border-radius: 50%;
    line-height: 20px;
    font-size: 13px;
    font-weight: bold;
  }

  .answer-content {
    position: relative;
    white-space: pre-wrap;
    line-height: 1.3;
    display: flex;
    flex-wrap: wrap;
    color: #04adc0;
    // font-weight: bold;

    & > span {
      &.order-sort {
        margin: 0 1px;
        border: 1px solid #04adc0;
        background-color: #fff;
        color: #04adc0 !important;
      }
    }

    &.type5 {
      & > span {
        margin-right: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SingleQuestion.vue